import _ from 'lodash';

export function fetchIdnWos_ac(idn, hdmsAccts) {
  return (dispatch) => {
    //params passed in by thunk middleware
    dispatch({ type: 'REQUEST_IDN_WOS', idn });
    let target_url = `/api/hdms:recentwos:prime`;
    let postData = { idn, hdmsAccts };
    let pkg = {};
    return window.sch
      .post(target_url, postData)
      .then((wosPkg) => {
        pkg = { ...wosPkg };

        let target_url = '/api/hdms:acct:prime';
        let postData = { idn, hdmsAccts };
        return window.sch.post(target_url, postData);
      })
      .then((acctPkg) => {
        pkg = { ...pkg, accounts: acctPkg.rr };

        //pkg: { "acctMember", "idnRecord", "newNotesCount", "counts", "pagination", "notes"}
        dispatch({ type: 'RECEIVED_IDN_WOS', pkg: pkg });
      })
      .catch((error) => {
        console.error('error:', error);
        dispatch({ type: 'FAILED_RECEIVED_IDN_WOS', error });
      });
  };
}

// On-demand fetch of archived work-order detail. The recentwos response flags
// archived WOs with `dtrack_archived` (index pointer, no S3). This pulls the
// actual archived docs from S3 via the backend and merges them back in as
// `dtrack`, so the UI shows full detail only when the user asks for it.
export function fetchArchivedIdnWos_ac(woIds) {
  return (dispatch, getState) => {
    if (!woIds || !woIds.length) return Promise.resolve();
    dispatch({ type: 'REQUEST_ARCHIVED_IDN_WOS' });
    return window.sch
      .post('/api/wos:archived:fetch', { wo_ids: woIds })
      .then((res) => {
        const dtrackByWo = (res && res.dtrack) || {};
        let pkg = _.cloneDeep(getState().idnWos.pkg);
        (pkg.wos || []).forEach((wo) => {
          const doc = dtrackByWo[wo.hdms_wId] || dtrackByWo[wo._id];
          if (doc) {
            wo.dtrack = doc;
            wo.dtrack_archived = null;
            wo.dtrack_restored = true;
          }
        });
        dispatch({ type: 'UPDATE_IDN_WOS_PKG', pkg });
      })
      .catch((error) => {
        console.error('error fetching archived wos:', error);
        dispatch({ type: 'FAILED_ARCHIVED_IDN_WOS', error });
      });
  };
}

export function selectIdnWosForToolsActivity_ac(params) {
  return (dispatch) => {
    //params passed in by thunk middleware
    dispatch({ type: 'UPDATE_IDN_WOS_ACTIVITY_PKG', activityPkg: params });
  };
}
export function clearIdnWosForToolsActivity_ac() {
  return (dispatch) => {
    //params passed in by thunk middleware
    dispatch({ type: 'CLEAR_IDN_WOS_ACTIVITY_PKG', activityPkg: null });
  };
}

export const updateWOLineItemsLocally_ac = (woPostInSet, lines, orig_lines) => {
  return (dispatch, getState) => {
    let pkg = _.cloneDeep(getState().idnWos.pkg);

    if (!_.get(pkg, ['wos', woPostInSet, 'dtrack', 'lines'], false)) return;

    pkg.wos[woPostInSet].dtrack.lines = _.cloneDeep(lines);
    pkg.wos[woPostInSet].dtrack.orig_lines = _.cloneDeep(orig_lines);

    dispatch({
      type: 'UPDATE_IDN_WOS_PKG',
      pkg,
    });
  };
};
